import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const RegistrationStep = styled.div<IThemeProps>`
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  position: relative;
  width: 100%;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    padding: 15px ${(props: IThemeProps) => props.theme.spacing.mobile.s500}px;

    /* ESD-2418 §3.7: ≥44px touch target for the form's submit/next buttons on mobile — scoped to
       the registration form so the shared button (quiz/poll/…) layout is untouched. */
    button {
      min-height: 44px;
    }
  }
`;

export const Title = styled.h1<IThemeProps>`
  height: 40px;
  line-height: 40px;
  font-size: ${(props: IThemeProps) => props.theme.typography.h500};
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  color: ${(props: IThemeProps) => props.theme.colors.black};
  margin-bottom: ${(props: IThemeProps) => props.theme.spacing.desktop.s300}px;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    margin-bottom: 0;
  }
`;
